import React, {
  DetailedHTMLProps,
  forwardRef,
} from 'react';
import clsx from 'clsx';
import isNil from 'lodash/isNil';
import InactiveOptionsToggle from 'pages/Dashboard/components/InactiveOptionsToggle';

const ProviderLookupListDropdown = forwardRef(({
  children,
  className,
  inactiveConfig,
  ...props
}: DetailedHTMLProps<any, any>, ref) => {
  const {
    showInactive,
    onToggleShowInactive,
    type = 'doctor',
    count = 0,
  } = inactiveConfig ?? {};

  return (
    <div className="h-full relative -m-2">
      <div
        {...props}
        className={clsx('!px-2 !pb-2', className)}
        ref={ref}
        role="listbox"
      >
        {children}
        {!isNil(inactiveConfig) && (
          <InactiveOptionsToggle
            label={`${type}s`}
            count={count}
            showInactive={showInactive}
            onToggle={onToggleShowInactive}
          />
        )}
      </div>
    </div>
  );
});

export default ProviderLookupListDropdown;
